import axios from 'axios';
import api, { NEXTJS_API_URL } from './client';

export const recruiterAPI = {
  getDashboard: async (params = "") => {
    try {
      const url = `${NEXTJS_API_URL}/recruiter/dashboard${params}`;
      const response = await axios.get(url, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
        },
      });
      return response.data;
    } catch (error) {
      console.error("Error fetching recruiter dashboard:", error);
      return {
        success: false,
        data: null,
        message: error.response?.data?.error || error.message,
      };
    }
  },
  getAllRecruiters: async () => {
    const response = await api.get("/recruiters");
    return response.data;
  },

  getRecruiterById: async (id) => {
    const response = await api.get(`/recruiters/${id}`);
    return response.data;
  },

  createRecruiter: async (recruiterData) => {
    const response = await api.post("/recruiters", recruiterData);
    return response.data;
  },

  updateRecruiter: async (id, recruiterData) => {
    const response = await api.put(`/recruiters/${id}`, recruiterData);
    return response.data;
  },

  deleteRecruiter: async (id) => {
    const response = await api.delete(`/recruiters/${id}`);
    return response.data;
  },

  getRecruitersByStatus: async (status) => {
    const response = await api.get(`/recruiters/status/${status}`);
    return response.data;
  },

  getByCountry: async (country) => {
    const response = await api.get(`/recruiters/by-country/${country}`);
    return response.data;
  },

  getWithBiodataCount: async () => {
    const response = await api.get("/recruiters/with-biodata-count");
    return response.data;
  },

  search: async (params) => {
    const response = await api.get("/recruiters/search", { params });
    return response.data;
  },
};

// Employer Management API
